"use strict";
import Swiper from "swiper";

export default function () {
    document.addEventListener("DOMContentLoaded", function () {
        // LOGICA DAS ABAS DE CONTEÚDO
        const tabs = document.querySelectorAll(".o-cronograma__tab");
        const dias = document.querySelectorAll(".o-cronograma__dia");

        tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                tabs.forEach((t) => t.classList.remove("is-active"));
                dias.forEach((d) => d.classList.remove("is-active"));

                tab.classList.add("is-active");
                document
                    .getElementById(tab.dataset.target)
                    .classList.add("is-active");
            });
        });

        // SWIPER DAS ABAS
        const cronogramaTabsSwiper = new Swiper("#cronogramaTabs", {
            slidesPerView: "auto",
            spaceBetween: 24,
            freeMode: true,
            grabCursor: true,
        });
    });
}
